module.exports = __webpack_public_path__ + "img/6.dadad5f1.png";